/* unplugin-vue-components disabled */import { render } from "./heroSubNavigation.vue?vue&type=template&id=ad5479c2"
import script from "./heroSubNavigation.vue?vue&type=script&lang=js"
export * from "./heroSubNavigation.vue?vue&type=script&lang=js"

import "./heroSubNavigation.vue?vue&type=style&index=0&id=ad5479c2&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__